/**
 * Stores a singleton object with a given key for the entire AC3 application.
 *
 * @param singletonKey: string  the key to identify the singleton object.
 * @param singletonObject: T the object to be stored as a singleton.
 * @return true if the singleton object was successfully stored, false if it already exists.
 */
export const setAppWideSingleton = (singletonKey, singletonObject) => {
    const symbolKey = Symbol.for(singletonKey);
    // we should use `symbolKey in global` but this fails unit tests in other packages
    if (!global[symbolKey]) {
        global[symbolKey] = singletonObject;
        return true;
    }
    return false;
};
/**
 * Retrieves a AC3 Global singleton object that was stored with a given key.
 *
 * @param singletonKey: string the key of the singleton object.
 * @return the singleton object associated with the given key, or undefined if it does not exist.
 */
export const getAppWideSingleton = (singletonKey) => {
    const symbolKey = Symbol.for(singletonKey);
    // we should use `symbolKey in global` but this fails unit tests in other packages
    if (global[symbolKey]) {
        return global[symbolKey];
    }
    return undefined;
};
//# sourceMappingURL=Singleton.js.map